import styled from '@emotion/styled';
import React from 'react';
import { Spotify } from '../../components/icons/Spotify';

const Host = styled.a`
  display: flex;
  flex-flow: column nowrap;

  cursor: pointer;

  &:hover {
    img:first-child {
      transform: scale(1.025);
    }
  }
`;

const Image = styled.figure`
  margin-bottom: 8px;
  position: relative;

  &:before {
    content: '';
    padding-bottom: 100%;
  }
`;
const Title = styled.div`
  margin-bottom: 14px;
`;

const Meta = styled.div`
  display: flex;
  flex-flow: row nowrap;

  margin-top: auto;
`;

const Icon = styled.div`
  height: 24px;
  width: 24px;
  margin-right: 25px;

  background-color: #ccc;
  border-radius: 99px;
`;

const Duration = styled.div`
  font-size: 14px;
  padding-top: 3px;
  line-height: ${20 / 14};
`;

interface IPodcast {
  title: string | null;
  image: React.ReactNode;
  duration: string | null;
}

export const PodcastItem = ({ title, image, duration, ...rest }: IPodcast) => {
  return (
    <Host {...rest}>
      <Image>{image}</Image>
      <Title>{title}</Title>
      <Meta>
        <Icon>
          <Spotify />
        </Icon>
        <Duration>{duration}</Duration>
      </Meta>
    </Host>
  );
};
